import { useEffect, useMemo, useRef } from "react";
import { createPureScopedStylesheet } from "../createStylesheet.js";
const usePureScopedStylesheet = (callback, settings, updateFromObject)=>{
    const result = useMemo(()=>createPureScopedStylesheet(callback, settings), []);
    const { updater } = result;
    if (updateFromObject && updater) {
        for(const k in updater){
            const isFirstRun = useRef(true);
            useEffect(()=>{
                var _updater_k;
                if (isFirstRun.current) {
                    isFirstRun.current = false;
                    return;
                }
                (_updater_k = updater[k]) == null ? void 0 : _updater_k.call(updater, updateFromObject[k]);
            }, [
                updateFromObject[k]
            ]);
        }
    }
    useEffect(()=>{
        result.toggle(true);
        return ()=>!(settings == null ? void 0 : settings.reuse) && result.toggle(false);
    }, []);
    return result;
};
export { usePureScopedStylesheet };
